import React, { useState, useContext, useEffect } from 'react';
import { Container, Row, Col, Spinner, Button, Form, Modal, Table } from 'react-bootstrap';
import { AppContext } from '../App';
import { apiRequest } from '../utils/apiHelper';

export const RenewAccount = () => {
    const { link, accessToken, setAccessToken, getLoad, setGetLoad, packages, recentRenew, setRecentRenew, setInvoice,
        setInvoiceModal
    } = useContext(AppContext);
    const [profile, setProfile] = useState();
    const [renewModal, setRenewModal] = useState(false);
    const getAccount = (e) => {
        e.preventDefault();
        let username = e.target.username.value;
        if (username === "") {
            alert('Please enter username');
            return;
        }
        apiRequest({
            url: `${link}api/cs/view/account/details/`,
            method: 'POST',
            data: {
                username: username,
            },
            token: accessToken,
            setLoading: setGetLoad,
            setAccessToken: setAccessToken,
            onSuccess: (data) => {
                setProfile(data);
                setRenewModal(true);
            },
            onError: () => {

            }
        });
    }
    useEffect(() => {
        if (!renewModal) {
            setProfile();
        }
    }, [renewModal]);
    const [renewLoad, setRenewLoad] = useState(false);
    const renewAccount = (e) => {
        e.preventDefault();
        let packageId = e.target.package.value;
        let staff = e.target.staff.value;
        let price = e.target.price.value;
        let offer_price = e.target.offer_price.value;
        let expiry_date = e.target.expiry_date.value;
        let payment_status = e.target.payment_status.value;
        if (packageId === "" || staff === "" || price === "" || offer_price === "" || expiry_date === "" || profile === undefined || payment_status === "") {
            alert('Please fill all the fields');
            return;
        }
        apiRequest({
            url: `${link}api/cs/renew/account/`,
            method: 'POST',
            data: {
                username: profile.main.username,
                package_id: packageId.substring(1),
                staff: staff,
                price: price,
                offer_price: offer_price,
                expiry_date: expiry_date,
                payment_status: payment_status
            },
            token: accessToken,
            setLoading: setRenewLoad,
            setAccessToken: setAccessToken,
            onSuccess: (data) => {
                setRecentRenew(prev => ({ ...prev, [data.id]: data.values }));
                setRenewModal(false);
            },
            onError: () => {
                alert('Something went wrong');
            }
        });
    }
    return (
        <Container className='py-2'>
            <Row className='bgs1 py-1 d-flex align-items-center bdr2 br-4 mb-3' >
                <Col xs={12} sm={12} md={6} lg={6}>
                    <span className='px-2'>Renew Account</span>
                </Col>
                <Col xs={12} sm={12} md={6} lg={6}>
                    <Form className='d-grid' onSubmit={getAccount} >
                        <Row >
                            <Col xs={12} sm={12} md={6} lg={8}>
                                <Form.Control type="text" name='username' placeholder="Enter account username" />
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={4}>
                                <div className='d-grid'>
                                    {
                                        getLoad ? (
                                            <Button variant="primary" disabled>
                                                <Spinner animation="border" size="sm" />
                                            </Button>
                                        ) : (
                                            <Button variant="primary" type="submit" >Get Account</Button>
                                        )
                                    }
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
            {
                recentRenew !== undefined && Object.keys(recentRenew).length > 0 ? (
                    Object.keys(recentRenew).map((item, i) => (
                        <Row className='bgs1 py-1 d-flex align-items-center bdr2 br-4 mb-2' >
                            <Col xs={12} sm={12} md={6} lg={8}>
                                <div className='d-grid'>
                                    <span>Agent : {recentRenew[item].agent}, Account : {recentRenew[item].username}</span>
                                    <span className='f14 ts2' >Package : {recentRenew[item].package_name}</span>
                                    <span className='f12 ts3' >Bill date : {recentRenew[item].bill_date}, Expiry : {recentRenew[item].expiry_date}</span>
                                </div>
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={4}>
                                <div className='flex-wrap justify-content-end align-items-center gap-2'>
                                    <span>Amount : {recentRenew[item].amount_payable}</span>
                                    <span className={recentRenew[item].paid ? 'success-tag' : 'error-tag'} >{recentRenew[item].paid ? 'Paid' : 'Pending'}</span>
                                    <Button onClick={() => {
                                        setInvoice(recentRenew[item]);
                                        setInvoiceModal(true);
                                    }} variant='info' size='sm' >Bill</Button>
                                </div>
                            </Col>
                        </Row>
                    ))
                ) : (
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <span>No recent renewals</span>
                        </Col>
                    </Row>
                )
            }
            <Modal show={renewModal} onHide={() => setRenewModal(false)} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Renew Account</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        getLoad ? (
                            <Spinner animation="border" size="sm" />
                        ) : (
                            profile !== undefined ? (
                                <>
                                    {
                                        profile.main !== undefined && Object.keys(profile.main).length > 0 ? (
                                            <>
                                                <div className='d-grid'>
                                                    <h5>Profile Details</h5>
                                                </div>
                                                <div className='flex-wrap align-items-center justify-content-space-around gap-2 mb-3'>
                                                    {
                                                        Object.keys(profile.main).map((item, i) => (
                                                            <div key={i} className='bgs1 bdr2 br-4 px-4 py-1' >
                                                                <span>{item} : {profile.main[item] ?? '-'}</span>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                                <div className='d-grid'>
                                                    <h5>Previous Renewal Details</h5>
                                                </div>
                                                <div className='flex-wrap align-items-center justify-content-space-around gap-2'>
                                                    {
                                                        profile.last_bill !== undefined && Object.keys(profile.last_bill).length > 0 ? (
                                                            <>
                                                                {
                                                                    Object.keys(profile.last_bill).map((item, i) => (
                                                                        <div key={i} className='bgs1 bdr2 br-4 px-4 py-1' >
                                                                            <span>{item} : {profile.last_bill[item] ?? '-'}</span>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                            </>
                                        ) : ''
                                    }
                                    <div className='d-grid pt-2'>
                                        <h5>Renewal Details</h5>
                                    </div>
                                    <Form className='bgs2 p-2 bdr1 br-4' onSubmit={renewAccount} >
                                        <Row>
                                            <Col xs={12} sm={12} md={6} lg={6}>
                                                <Form.Group>
                                                    <Form.Label>Package</Form.Label>
                                                    <Form.Select name='package'>
                                                        <option value="">Select Package</option>
                                                        {
                                                            packages !== undefined && Object.keys(packages).length > 0 ? (
                                                                Object.keys(packages).map((item, i) => (
                                                                    <option key={i} value={item} >{packages[item].name}</option>
                                                                ))
                                                            ) : ''
                                                        }
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} sm={12} md={6} lg={6}>
                                                <Form.Group>
                                                    <Form.Label>Number of staff accounts</Form.Label>
                                                    <Form.Control type="number" name='staff' placeholder='Number of staff accounts' />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={12} sm={12} md={6} lg={6}>
                                                <Form.Group>
                                                    <Form.Label>Price</Form.Label>
                                                    <Form.Control type="number" name='price' placeholder='Price' />
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} sm={12} md={6} lg={6}>
                                                <Form.Group>
                                                    <Form.Label>Offer price</Form.Label>
                                                    <Form.Control type="number" name='offer_price' placeholder='Offer price' />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={12} sm={12} md={6} lg={6}>
                                                <Form.Group>
                                                    <Form.Label>Expiry Date</Form.Label>
                                                    <Form.Control type="date" name='expiry_date' placeholder='Expiry Date' />
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} sm={12} md={6} lg={6}>
                                                <Form.Group>
                                                    <Form.Label>Payemnt Status</Form.Label>
                                                    <Form.Select name='payment_status'>
                                                        <option value="">Select Payment Status</option>
                                                        <option value="pending">Pending</option>
                                                        <option value="completed">Completed</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <div className='d-grid py-2'>
                                            {
                                                renewLoad ? (
                                                    <Button variant="primary" disabled>
                                                        <Spinner animation="border" size="sm" />
                                                    </Button>
                                                ) : (
                                                    <Button type='submit'>Submit</Button>
                                                )
                                            }
                                        </div>
                                    </Form>
                                </>
                            ) : (
                                'Nothing Found'
                            )
                        )
                    }
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>
        </Container >

    )
}